module.exports = __webpack_public_path__ + "img/stepProcessing.d05ff73b.gif";